module.exports = __webpack_public_path__ + "static/img/realTime.18d6a6c8.png";